export default function dataExportsReducer(state = {
    files: [],
    history: [],
    checkedList: [],
    errorsHistory: [],
    progress: [],
    fetching: false,
    fetched: false,
    errors: {}
}, action) {
    switch (action.type) {
        case 'GET_UPLOADED_FILE_PENDING':
        case 'GET_DATA_IMPORT_LIST_PENDING': {
            return {
                ...state,
                fetching: true,
                fetch: false
            }
        }
        case
        'GET_DATA_IMPORT_LIST_FULFILLED'
        : {

            return {
                ...state,
                fetching: false,
                fetched: true,
                files: action.payLoad.unprocessed,
                history: action.payLoad.import_history
            }
        }
        case 'DELETE_IMPORT_FILES_REJECTED':
        case 'GET_UPLOADED_FILE_REJECTED':
        case 'GET_DATA_IMPORT_LIST_REJECTED': {
            return {
                ...state,
                errors: action.payLoad
            }
        }
        case 'DELETE_IMPORT_FILES_FULFILLED': {
            const files = state.files.filter(e => action.payLoad.find(deletedFile => e == deletedFile) == undefined);
            return {
                ...state,
                fetching: false,
                fetched: true,
                files: files
            }
        }
        case 'ADD_TO_HISTORY':
        case 'GET_UPLOADED_FILE_FULFILLED': {
            let history = state.history;
            history.unshift(action.payLoad.import_history);

            return {
                ...state,
                fetching: false,
                fetched: true,
                history: history
            }
        }

        case 'ADD_IMPORT_FILES_FULFILLED': {
            let list = state.checkedList;
            list.push(action.payLoad);
            return {
                ...state,
                checkedList: list
            }
        }

        case 'POST_IMPORT_FULFILLED': {
            return {
                ...state,
                progress: action.payLoad,
            }
        }

        case 'POST_IMPORT_REJECTED': {
            return {
                ...state,
                errorsHistory: action.payLoad,
            }
        }
        case 'CLEAR_ERRORS_HISTORYs': {
            return {
                ...state,
                errorsHistory: action.payLoad,
            }
        }

        default:
            return {...state};
    }
}



// WEBPACK FOOTER //
// ./src/reducers/dataImportReducer.js